// src/config/paystack.js
export const PAYSTACK_CONFIG = {
  // Test keys (sandbox) - Hardcoded for reliability
  publicKey: 'pk_test_c5bb23478d58671723ac7dc6cc3c4ae9787e840f',
  secretKey: 'sk_test_444d29c1a64809e8b6ab51bdcc2c7e38df7ecf4d',
  
  // Production URLs for pcfgym.co.ke
  callbackUrl: 'https://pcfgym.co.ke/payment-confirmation',
  webhookUrl: 'https://pcfgym.co.ke/api/paystack-webhook',
  
  // Local development URLs
  localCallbackUrl: 'http://localhost:3000/payment-confirmation',
  localWebhookUrl: 'http://localhost:3000/api/paystack-webhook',
};

export const PAYMENT_TYPES = {
  MEMBERSHIP: 'membership',
  TRAINER_GROUP: 'trainer_group',
  TRAINER_PERSONAL: 'trainer_personal',
  SHOP: 'shop',
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

// Helper function to get current environment callback URL
export const getCallbackUrl = () => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return PAYSTACK_CONFIG.localCallbackUrl;
    }
    return `${window.location.origin}/payment-confirmation`;
  }
  return PAYSTACK_CONFIG.callbackUrl;
};

// WhatsApp configuration
export const WHATSAPP_CONFIG = {
  number: '254117110000',
  messageTemplate: (plan, customerName = '') => {
    return encodeURIComponent(
      `🏋️‍♂️ *Trainer Session Enquiry - PCF Gym* 🏋️‍♀️\n\n` +
      `*Website:* pcfgym.co.ke\n` +
      `*Selected Plan:* ${plan.title}\n` +
      `*Price:* KES ${plan.price.toLocaleString()} ${plan.duration}\n\n` +
      `*Customer Name:* ${customerName || '[Your Name]'}\n` +
      `*Preferred Time:* [Morning/Afternoon/Evening]\n\n` +
      `Please share more details. Thank you! 🙏`
    );
  },
};